import { Component, OnInit, Input, ViewChild, ElementRef, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { fromEvent } from 'rxjs';
import { isEmpty, startWith, distinctUntilChanged, map } from 'rxjs/operators';
import { debounceTime } from 'rxjs/operators';
import { ExamsService } from 'src/app/services/exams.service';
import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  @Input('searchFor') searchFor;
  @Input('jobId') jobId;
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;

  @Output() examsResult: EventEmitter<any> = new EventEmitter<any>();

  compList = ['exam-results']

  searchText;
  constructor(private activatedRoute: ActivatedRoute,public _examService: ExamsService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.jobId = params['jobid'];
      console.log("Calling getLearnersFromComponent with jobid = ", this.jobId);
    })
  
    console.log("search for -- component", this.searchFor, this.jobId)
    fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      map((event: any) => {
        return event.target.value;
      })
      , debounceTime(500), distinctUntilChanged()
    ).subscribe((searchTextValue: any) => {
      console.log("searchText", this.searchText, "searchTextValue", searchTextValue)
      switch (this.searchFor) {
        case 'exam-results':
          let obj = {
            jobId : this.jobId,
            searchText: searchTextValue
          }
          this._examService.getExamMarks(this.jobId).subscribe((marks) => {
            console.log("MARKS DATA IN SEARCH", marks.response)
            this.examsResult.emit({ res: marks.response})
          })
        break;
      
        default:
        break;
}
    });
  }
ngOnChanges(changes: SimpleChanges): void {
  console.log("changes", changes)
    if(changes.jobId){
  this.jobId = changes.jobId.currentValue
}
  }

  // filter(){
  //   console.log("FILTER called", this.searchText)
  // }
}
